import { SitePickerForOrgField } from '@monorepo/shared/componentsV2/fields/SitePickerForOrgField';
import {
  StyledFormGroup,
  StyledInput,
} from '@monorepo/shared/componentsV2/styled/form';
import { isRequired } from '@monorepo/shared/utils/validators';
import { ResourceResponse, ResourceTypeRefResponse } from 'mapistry-shared';
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';

type EditResourceBuiltInFieldsProps = {
  organizationId: string;
  resourceType: ResourceTypeRefResponse;
  existingResource?: ResourceResponse;
  onNameSync: (name: string | undefined) => void;
};

export function EditResourceBuiltInFields({
  organizationId,
  resourceType,
  existingResource,
  onNameSync,
}: EditResourceBuiltInFieldsProps) {
  const {
    input: { value: nameValue },
  } = useField<ResourceResponse['name']>('name', {
    subscription: { value: true },
    initialValue: existingResource?.name,
  });

  useEffect(() => {
    onNameSync(nameValue);
  }, [nameValue, onNameSync]);

  return (
    <StyledFormGroup row>
      <StyledInput<ResourceResponse['name']>
        label="Resource Name"
        name="name"
        placeholder="Name"
        validate={isRequired}
        required
        initialValue={existingResource?.name}
      />
      {resourceType?.isSiteSpecific && (
        <SitePickerForOrgField
          organizationId={organizationId}
          label="Site Association"
          name="projectId"
          validate={isRequired}
          required
          initialValue={existingResource?.project?.id}
        />
      )}
    </StyledFormGroup>
  );
}
